import { all } from "redux-saga/effects";

//public
import AuthSaga from "./auth/saga";
import ProfileSaga from "./profile/saga";
import LayoutSaga from "./layout/saga";
// Test
import TestSaga from "./test/saga";
// Custom
import DataSaga from "./data/saga";
import TaskSaga from "./task/saga";
import ContractSaga from "./contract/saga";
import SearchEmployeeSaga from "./employee/saga";
import CardPurchaseSaga from "./card/saga";
import ClientSaga from "./client/saga";
import ScrapingRunsSaga from "./scraping/saga";
// Tax Portal
import TaxPortal from "./taxPortal/saga";
import CustodianSaga from "./custodian/saga";

export default function* rootSaga() {
  yield all([
    //public
    AuthSaga(),
    ProfileSaga(),
    LayoutSaga(),
    // Tset
    TestSaga(),
    // Custom
    DataSaga(),
    TaskSaga(),
    ContractSaga(),
    SearchEmployeeSaga(),
    CardPurchaseSaga(),
    ClientSaga(),
    ScrapingRunsSaga(),
    // Tax Portal
    TaxPortal(),
    CustodianSaga(),
  ]);
}
